import React from 'react';
import './EllipseLoader.css'; // Import the CSS for animation

const EllipseLoader = () => {
  return (
    <div className="ellipse-loader">
      <div className="ellipse"></div>
      <div className="ellipse"></div>
      <div className="ellipse"></div>
    </div>
  );
};

export default EllipseLoader;